// extracted by mini-css-extract-plugin
module.exports = {"center":"videoArticle_center__w_It3","spin":"videoArticle_spin__h4v3S","circle":"videoArticle_circle__wlW8K","fade-spin":"videoArticle_fade-spin__lwGBw"};